// 口碑赞誉弹窗
<template>
  <a-drawer
    placement="right"
    :visible="visible"
    @close="handleClose"
    wrapClassName="satisfaction_popover"
    title="口碑赞誉"
    :drawerStyle="drawerWrapStyle"
    :bodyStyle="drawerBodyStyle"
    :headerStyle="headerStyle"
    :width="432"
    destroyOnClose
  >
    <div class="wrap" :class="{ spinning: loading }">
      <div class="header">
        <a-range-picker
          v-model:value="dateList"
          :placeholder="['开始日期', '结束日期']"
          allowClear
          format="YYYY-MM-DD"
          :ranges="rangePresets"
          dropdownClassName="creatTime"
          :disabledDate="disabledDate"
          @change="getData(1)"
        />
        <div class="categorization z-flex">
          <div
            v-for="item in feedbackTypeMap"
            :key="item.key"
            class="item"
            :class="{ active: item.value === searchParams.feedbackType }"
            :style="item.value === searchParams.feedbackType ? activeStyle : {}"
            @click="handlePick(item.value)"
          >
            <div class="num">{{ item.num }}</div>
            <div class="lable">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="content" :style="patientBgStyle">
        <div class="title z-flex-c">
          <div class="lable">
            {{ activeKey === 'patientDetailList' ? '患者列表' : '患者评价' }}
          </div>
          <div class="btns z-flex" v-if="activeKey === 'patientDetailList'">
            <div class="btn sort z-flex" @click="handleSort">
              <span>排序</span>
              <img :src="sortMap[searchParams.sort].icon" class="img" />
            </div>
            <div class="_input">
              <a-input
                placeholder="搜索患者姓名/手机号"
                v-model:value="searchParams.searchParam"
                @change="handleInput"
              >
                <template #prefix><SearchOutlined class="search_icon" /></template>
              </a-input>
            </div>
          </div>
          <div class="btns z-flex" v-show="searchParams.feedbackType === 4">
            <div class="btn btn-select">
              <a-select
                placeholder="全部审核状态"
                v-model:value="searchParams.status"
                style="width: 130px"
                allowClear
                @change="getData(1)"
                :bordered="false"
              >
                <a-select-option
                  v-for="item in auditStatusMap"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
            <div class="btn btn-select">
              <a-select
                placeholder="全部来源"
                v-model:value="searchParams.evaluatorType"
                style="width: 120px"
                allowClear
                @change="getData(1)"
                :bordered="false"
              >
                <a-select-option
                  v-for="item in sourceTypeMap"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <a-spin class="spinning" :spinning="loading">
          <div class="list" ref="listRef">
            <template v-if="activeKey === 'patientDetailList'">
              <div
                class="item"
                v-for="item in listData.patientDetailList"
                :key="item.ucPatientId"
                @click="goDetail(item)"
              >
                <div class="info z-flex">
                  <div class="avator">
                    <a-avatar shape="square" :size="44" :src="item.headUrl">
                      <template #icon><UserOutlined /></template>
                    </a-avatar>
                  </div>
                  <div class="ext">
                    <div class="name">
                      <span class="span-1" v-if="item.patientName">{{ item.patientName }}</span>
                      <span class="span-2" v-if="['女', '男'][item.sex]">
                        {{ ['女', '男'][item.sex] }}
                      </span>
                      <span class="span-2 age" v-if="item.age || item.age === 0">
                        {{ item.age }}岁
                      </span>
                      <span
                        class="span-3"
                        v-for="(project, index) in item.activeProjectsStr"
                        :key="index"
                      >
                        {{ project }}
                      </span>
                    </div>
                    <div class="last">{{ currentDataText(item.lastOperateTime) }}</div>
                  </div>
                </div>
                <div class="data">
                  <div
                    v-for="it in praiseItems"
                    :key="it.key"
                    class="data-item"
                    :style="it.style"
                    @click.stop="goDetail(item, it.value)"
                  >
                    <img :src="it.icon" class="img" />
                    <span style="margin-left: 8px">
                      {{ it.label }}
                      {{ item[it.key] }}
                    </span>
                    <RightOutlined class="right-icon" />
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="item evaluate-item"
                v-for="item in listData.evaluationList"
                :key="item.id"
                @click="goDetail(item)"
              >
                <div class="info z-flex-c">
                  <div class="avator z-flex">
                    <a-avatar shape="square" :size="24" :src="item.patientHeadUrl">
                      <template #icon><UserOutlined /></template>
                    </a-avatar>
                    <div class="name">{{ item.patientName }}</div>
                    <div class="score">
                      <img
                        :src="star"
                        alt=""
                        class="star"
                        v-for="it in scoreRange(item.score)"
                        :key="it"
                      />
                      <img
                        v-for="it in scoreRange(5 - item.score)"
                        :key="it"
                        :src="emptyStar"
                        alt=""
                        class="star"
                      />
                    </div>
                  </div>
                  <div class="ext">{{ moment(item.evaluateTime).format('YYYY-MM-DD HH:mm') }}</div>
                </div>
                <div class="content-wrap" v-if="formatContent(item.content).length">
                  <input type="checkbox" :id="`exp-${item.id}`" class="_input" @click.stop />
                  <div class="content-box">
                    <img :src="mark" alt="" class="mark" />
                    <div
                      class="letter-content"
                      v-for="(line, index) in formatContent(item.content)"
                      :key="index"
                    >
                      {{ line }}
                    </div>
                    <label class="expand" :for="`exp-${item.id}`" @click.stop></label>
                  </div>
                </div>
                <div class="badge z-flex">
                  <span class="primary" v-if="item.chosenStatus">精选</span>
                  <span
                    v-if="auditStatusMap[item.auditStatus]"
                    :style="auditStatusMap[item.auditStatus].style"
                  >
                    {{ auditStatusMap[item.auditStatus].label }}
                  </span>
                  <span class="primary" v-if="[1, 2, 3].includes(item.evaluatorType)">
                    {{ ['', '系统自填', '患者填写', '医助代填'][item.evaluatorType] }}
                  </span>
                </div>
              </div>
            </template>
            <div v-if="listData[activeKey].length === 0">
              <a-empty />
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </a-drawer>
  <Detail ref="detailRef" />
</template>
<script setup>
import { ref, defineExpose, reactive, nextTick, computed } from 'vue'
import Detail from './components/detail.vue'
import star from '@/assets/img/pennant/star.png'
import emptyStar from '@/assets/img/pennant/empty_star.png'
import mark from '@/assets/img/pennant/mark.png'
import { getReputationList } from '@/api/workPlace/satisfaction.js'
import {
  defaultFeedbackTypeMap,
  praiseItems,
  auditStatusMap,
  sourceTypeMap,
  drawerWrapStyle,
  drawerBodyStyle,
  headerStyle,
  activeStyle,
  patientBgStyle,
  formatContent,
  sortMap,
  rangePresets
} from './config.js'
import { debounce } from 'lodash-es'
import { SearchOutlined, UserOutlined, RightOutlined } from '@ant-design/icons-vue'
import { formatDateForFilter, scoreRange } from '@/utils'
import moment from 'moment'
const activeKey = computed(() => {
  return [1, 2, 3].includes(searchParams.feedbackType) ? 'patientDetailList' : 'evaluationList'
})
const visible = ref(false)
const dateList = ref([])
const feedbackTypeMap = ref({ ...defaultFeedbackTypeMap })
const defaultSearchParams = {
  searchParam: '',
  feedbackType: 1,
  status: null,
  evaluatorType: null,
  sort: 0, //排序：0-默认 1-正序，2-倒序（默认按照最近一次操作倒序排列）
  pageNo: 1,
  pageSize: 10,
  ucDoctorId: ''
}
const searchParams = reactive({})
const hasNext = ref(false)
const loading = ref(false)
const listData = reactive({
  patientDetailList: [], //患者列表
  evaluationList: [] // 患者评价
})
// 查询数据
function getData(pageNo) {
  loading.value = true
  const query = {
    ...searchParams,
    pageNo: pageNo || searchParams.pageNo
  }
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  query.startDateTime = startTime
  query.endDateTime = endTime
  const _activeKey = activeKey.value
  getReputationList(query)
    .then(data => {
      const currentData = data[_activeKey] || []
      const { currPage, list } = currentData
      feedbackTypeMap.value = defaultFeedbackTypeMap.map(item => {
        item.num = data[item.key] || 0
        return item
      })
      if (currPage === 1) {
        listData[_activeKey] = list || []
      } else {
        listData[_activeKey] = listData[_activeKey].concat(list || [])
      }
      searchParams.pageNo = currPage + 1
      hasNext.value = currentData.hasNext
    })
    .catch(() => {
      listData[_activeKey] = []
    })
    .finally(() => {
      loading.value = false
    })
}
// 监听页面滚动事件
function handleScroll({ target }) {
  const DOM = target
  const scrollHeight = DOM.scrollHeight, //滚动条的高度
    scrollTop = DOM.scrollTop, //滚动条在Y轴滚动过的高度
    clientHeight = DOM.clientHeight //浏览器的可视高度
  if (scrollHeight - scrollTop - clientHeight < 1 && hasNext.value) {
    getData()
  }
}
// 排序事件
const handleSort = () => {
  const _index = sortMap.findIndex(it => it.value === searchParams.sort) + 1
  const index = _index > 2 ? 0 : _index
  searchParams.sort = sortMap[index]?.value || 0
  getData(1)
}
// 分类选择事件
const handlePick = key => {
  searchParams.feedbackType = key
  getData(1)
}
const handleInput = debounce(() => {
  getData(1)
}, 500)
// 查看详情
const detailRef = ref(null)
// 查看详情点击事件
const goDetail = (item, feedbackType) => {
  detailRef.value.initModal({
    ...item,
    feedbackType: feedbackType || searchParams.feedbackType
  })
}
const listRef = ref(null)
const initModal = params => {
  visible.value = true
  dateList.value = []
  Object.assign(searchParams, defaultSearchParams)
  searchParams.ucDoctorId = params.ucDoctorId
  getData()
  nextTick(() => {
    listRef.value.addEventListener('scroll', handleScroll)
  })
}
//
const currentDataText = num => {
  const item = feedbackTypeMap.value.find(i => i.value === searchParams.feedbackType)
  const currentText = item?.currentText || ''
  return `${currentText} ${num}`
}
// 禁止筛选今天以后的时间
const disabledDate = current => {
  return current && current > moment().endOf('day')
}
// 关闭弹窗
const handleClose = () => {
  visible.value = false
  listRef.value.removeEventListener('scroll', handleScroll)
}

defineExpose({ initModal })
</script>

<style scoped lang="scss">
.satisfaction_popover {
  .wrap {
    height: calc(100vh - 55px);
    &.spinning {
      pointer-events: none;
    }
  }
  .header {
    padding: 20px 20px 10px;
    ::v-deep(.ant-calendar-picker) {
      width: 100%;
      .ant-input {
        border-radius: 8px;
        background: #ffffff;
        padding: 8px 11px;
        border: none;
      }
      .ant-calendar-range-picker-input {
        width: calc(50% - 5px);
      }
    }
    .categorization {
      margin-top: 20px;
      .item {
        flex: 1;
        margin-right: 8px;
        text-align: center;
        cursor: pointer;
        :last-child {
          margin-right: 0;
        }
        &.active {
          .num,
          .lable {
            color: #ffffff;
            background: transparent;
          }
        }
      }
      .num {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        padding-top: 7px;
        border-radius: 8px 8px 0 0;
        background-color: #ffffff;
      }
      .lable {
        background-image: linear-gradient(180deg, #ffffff 3%, #fde3d9 97%);
        padding-bottom: 9px;
        font-weight: 400;
        font-size: 13px;
        line-height: 18px;
        border-radius: 0 0 8px 8px;
      }
    }
  }
}
.content {
  padding: 0 20px 0;
  border-radius: 16px 16px 0 0;
  .title {
    padding: 11px 0;
    .lable {
      font-weight: 500;
      font-size: 16px;
      color: #1b1b1b;
    }
    .btns {
      .btn {
        cursor: pointer;
        padding: 5px 12px;
        border-radius: 16px;
        background: #ffffffb3;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: center;
        margin-right: 16px;
        &:last-child {
          margin-right: 0;
        }
        &.btn-select {
          padding: 0 12px;
          ::v-deep(.ant-select-selector) {
            height: 32px;
            .ant-select-selection-search-input {
              height: 32px;
            }
          }
        }
        &.sort {
          align-items: center;
          .img {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
        }
      }
      ._input {
        .search_icon {
          font-size: 12px;
          color: #333333;
        }
        ::v-deep(.ant-input-affix-wrapper) {
          padding: 5px 12px;
          border-radius: 16px;
          background: #ffffffb3;
          width: 214px;
          border: none;
          .ant-input {
            background-color: transparent;
          }
        }
      }
    }
  }
  .list {
    height: calc(100vh - 265px);
    overflow-y: scroll;
    cursor: pointer;
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      margin-bottom: 12px;
      border-radius: 12px;
      background: #ffffff;
      padding: 14px 12px;
      .info {
        justify-content: flex-start;
        .avator {
          margin-right: 10px;
          ::v-deep(.ant-avatar) {
            border-radius: 8px;
          }
        }
        .ext {
          .name {
            span {
              margin-right: 8px;
            }
            .span-1 {
              font-weight: 500;
              font-size: 16px;
              color: #333333;
            }
            .span-2 {
              font-weight: 400;
              font-size: 14px;
              color: #666666;
              margin-right: 6px;
              &.age {
                margin-right: 8px;
              }
            }
            .span-3 {
              border-radius: 4px;
              background: #fbf3ee;
              font-weight: 500;
              font-size: 12px;
              color: #b27e55;
              height: 22px;
              line-height: 17px;
              padding: 2px 6px;
            }
          }
          .last {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }
      .data {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .data-item {
          padding: 4px;
          border-radius: 4px;
          margin-right: 12px;
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .right-icon {
            font-size: 10px;
            margin-left: 3px;
          }
          .img {
            width: 16px;
            height: 16px;
          }
        }
      }
      .currentData {
        margin-top: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        span {
          font-weight: 500;
        }
      }
    }
    .evaluate-item {
      margin-top: 12px;
      .info {
        justify-content: space-between;

        .avator {
          align-items: center;
          ::v-deep(.ant-avatar) {
            border-radius: 4px;
          }
          .name {
            margin-left: 10px;
            font-weight: 500;
            font-size: 16px;
            color: #333333;
          }
          .score {
            margin-left: 6px;
            .star {
              width: 16px;
              height: 16px;
              margin-right: 2px;
            }
          }
        }
        .ext {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
      }
      .content-wrap {
        position: relative;
        margin-top: 14px;
        ._input {
          display: none;
        }
        .content-box {
          max-height: 120px;
          overflow: hidden;
          font-weight: 400;
          font-size: 14px;
          color: #1c1c1c;
          line-height: 24px;
          position: relative;
          .mark {
            position: absolute;
            top: -1px;
            left: 0;
            width: 24px;
            height: 24px;
          }
          .letter-content {
            text-indent: 2em;
          }
          .expand {
            position: absolute;
            top: 96px;
            right: 0;
            cursor: pointer;
            font-weight: 400;
            font-size: 14px;
            color: #3f64ff;
            height: 24px;
            line-height: 24px;
            background-image: linear-gradient(270deg, #fffbf9 81%, #fffbf900 100%);
            padding-left: 18px;
            width: 64px;
            height: 24px;
            text-align: right;
            &::after {
              content: '展开';
            }
          }
        }
        ._input:checked + .content-box {
          max-height: fit-content;
          .after {
            visibility: hidden;
          }
          .expand {
            bottom: 0;
            top: auto;
            &::after {
              content: '收起 ';
            }
          }
        }
      }
    }
    .badge {
      justify-content: flex-start;
      margin-top: 6px;
      align-items: center;
      span {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        display: inline-block;
        padding: 2px 6px;
        border-radius: 4px;
        border: 1px solid #ff89264d;
        margin-right: 6px;
        &.primary {
          color: #ff8926;
          border-color: #ff89264d;
        }
      }
    }
  }
}
</style>
